import type { DialogButtonTemplateParams } from 'Components/smallComponents/dialogButton';
import type { TemplateFunction, TemplateFunctionInvoker, TemplateResult } from 'Components/types';

import AddButton from '../addButton';
import type { VehicleDropdownsParams } from './vehicleDropdowns';

interface Props {
  template: TemplateFunction<EmptyDropdownTemplateParams>;
  closeGarage: () => void;
  showVehicleDropdowns: () => void;
  vehicleWidget: TemplateFunctionInvoker<VehicleDropdownsParams>;
}

export interface EmptyDropdownTemplateParams {
  addButton: (templ: TemplateFunction<DialogButtonTemplateParams>) => TemplateResult;
  closeGarage: () => void;
  showVehicleDropdowns: () => void;
  vehicleWidget: (templ: TemplateFunction<VehicleDropdownsParams>) => TemplateResult;
  template: 'empty';
}

export default function EmptyDropdown({
  template,
  closeGarage,
  showVehicleDropdowns,
  vehicleWidget,
}: Props): TemplateResult {
  const addButton = (templ: TemplateFunction<DialogButtonTemplateParams>) => (
    <AddButton closeGarage={closeGarage} template={templ} key="add" />
  );

  return template.call({ addButton, closeGarage, showVehicleDropdowns, vehicleWidget, template: 'empty' });
}
